import { api } from '@/config'
import httpApi from '@/util/http-api'

export default {
  getApplicationStatus: (data) => {
    return httpApi.getDataViaApi(api.applications + '/' + data.code + '/status?email=' + data.email)
  }
}
